import React from 'react';
import ConfirmationForm from '../ConfirmationForm';
import { statusMeta, subjectLabel } from './timeEntryCard';

// Renderer for the track-time-preflight result: the review-and-confirm form. It reuses the generic
// ConfirmationForm the way a specialized pivot reuses Pivot, supplying the time-entry specifics — status as
// a corner icon, a duplicate warning as an inline note, and a "Track time" action that logs the ready rows.
const readyCount = (data) => (Array.isArray(data) ? data : []).filter((row) => row.status === 'ready').length;

export default function TrackTimePreflight({ data, fields, isLast }) {
  return (
    <ConfirmationForm
      data={data}
      fields={fields}
      isLast={isLast}
      title="Review the time to be logged"
      confirmLabel="Track time"
      itemLabel="entries"
      omitFields={['status']}
      statusFor={statusMeta}
      labelFor={subjectLabel}
      noteFor={(row) => row.warning ?? null}
      canConfirm={(rows) => readyCount(rows) > 0}
      confirmMessage={(rows) =>
        readyCount(rows) === 1 ? 'Confirmed — log this entry now.' : 'Confirmed — log these entries now.'
      }
    />
  );
}
